import apiClient from "../../../../../../services/apiClient";


export async function getPCInfo(kg_id){
    
    if(!kg_id) return { error: 'kg_id not defined'};

    const url = `addinfo/pcinfo?kindergarten_id=${kg_id}`;

    try{

        const result = await apiClient.get(url);

        return result;

    } catch (err){

        return err;
    }

} 

export async function savePCInfo(kg_id, data){
    
    if(!kg_id) return { error: 'kg_id not defined'};

    const url = `addinfo/pcinfo?kindergarten_id=${kg_id}`;

    try{
        const result = await apiClient.post(url, data);

        return result;

    } catch (err){
        return err;
    }


}

export async function getBDInfo(kg_id){


    if(!kg_id) return { error: 'kg_id not defined'};
    
    const url = `addinfo/bdinfo?kindergarten_id=${kg_id}`;

    try{

        const result = await apiClient.get(url);

        return result;

    } catch (err){

        return err;
    }

}
 


export async function saveBDInfo(kg_id, data){

    if(!kg_id) return { error: 'kg_id not defined'};
    
    const url = `addinfo/bdinfo?kindergarten_id=${kg_id}`;

    try{
        const result = await apiClient.post(url, data);

        return result;
    } catch (err){
        return err;
    }
    
}